const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
const finePointer = window.matchMedia("(pointer: fine)");
const liquidSelector = [
  ".program-hero",
  ".kpi-card",
  ".panel",
  ".project-card",
  ".gate-card",
  ".phase-node",
  ".schema-card",
  ".online-member",
  ".nav-item",
  ".button",
  ".icon-button",
  ".user-menu-button",
  ".language-switch",
  ".command-search",
  ".density-toggle"
].join(",");

function setSpotlight(element, event) {
  const rect = element.getBoundingClientRect();
  const x = Math.max(0, Math.min(rect.width, event.clientX - rect.left));
  const y = Math.max(0, Math.min(rect.height, event.clientY - rect.top));
  element.style.setProperty("--glass-x", `${x}px`);
  element.style.setProperty("--glass-y", `${y}px`);

  if (!element.matches(".program-hero,.kpi-card,.project-card")) return;
  const rotateX = ((y / rect.height) - 0.5) * -1.5;
  const rotateY = ((x / rect.width) - 0.5) * 1.5;
  element.style.setProperty("--tilt-x", `${rotateX.toFixed(2)}deg`);
  element.style.setProperty("--tilt-y", `${rotateY.toFixed(2)}deg`);
}

function resetSpotlight(element) {
  element.style.removeProperty("--tilt-x");
  element.style.removeProperty("--tilt-y");
}

function bindElement(element) {
  if (element.dataset.liquidBound === "true") return;
  element.dataset.liquidBound = "true";
  element.classList.add("liquid-reactive");

  if (!finePointer.matches || reducedMotion.matches) return;
  element.addEventListener("pointermove", event => setSpotlight(element, event), { passive: true });
  element.addEventListener("pointerleave", () => resetSpotlight(element), { passive: true });
}

export function hydrateLiquidUI(root = document) {
  if (root instanceof Element && root.matches(liquidSelector)) bindElement(root);
  root.querySelectorAll?.(liquidSelector).forEach(bindElement);
}

function updateAmbientPointer(event) {
  if (!finePointer.matches || reducedMotion.matches) return;
  document.documentElement.style.setProperty("--pointer-x", `${event.clientX}px`);
  document.documentElement.style.setProperty("--pointer-y", `${event.clientY}px`);
}

export function startLiquidUI() {
  hydrateLiquidUI(document);
  document.addEventListener("pointermove", updateAmbientPointer, { passive: true });

  const app = document.getElementById("app");
  if (app) {
    const observer = new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node instanceof Element) hydrateLiquidUI(node);
      }));
    });
    observer.observe(app, { childList: true, subtree: true });
  }
}
